import moment from 'moment';

export const normalizeDay = date => moment(date).startOf('day');

export const getToday = () => moment().startOf('day');

export const getEarliestDate = dates => moment(Math.min(...dates.map(date => normalizeDay(date).valueOf())));

export const getLatestDate = dates => moment(Math.max(...dates.map(date => normalizeDay(date).valueOf())));

export const normalizeDateForServer = date => {
    if (!date) {
        return undefined;
    }

    try {
        return new Date(date).toISOString();
    } catch (e) {
        return undefined;
    }
}

export const getDatesArray = (start, end) => {
    const days = [];
    let day = start;

    while (day <= end) {
        days.push(day.toDate());
        day = day.clone().add(1, 'd');
    }

    return days;
}

const TIME_FORMATS = {
    '12h': 'h:mma',
    '24h': 'H:mm'
};

export const getDateFormats = timeFormat => {
    const time = TIME_FORMATS[timeFormat];

    return {
        'mm/dd/yyyy': {
            time: time,
            date: 'MMM D',
            longDate: 'dddd, MMMM D',
            dateTimeShort: `MMM D, ${time}`,
            dateTime: `MMM D [at] ${time}`,
            fullDate: 'MMM D, YYYY',
            machineFriendlyFullDate: 'MM/DD/YYYY',
            fullDateTime: `MMM D, YYYY [at] ${time}`,
        },

        'dd/mm/yyyy': {
            time: time,
            date: 'D MMM',
            longDate: 'dddd, D MMMM',
            dateTimeShort: `D MMM, ${time}`,
            dateTime: `D MMM [at] ${time}`,
            fullDate: 'D MMM, YYYY',
            machineFriendlyFullDate: 'DD/MM/YYYY',
            fullDateTime: `D MMM, YYYY [at] ${time}`
        },

        'yyyy/mm/dd': {
            time: time,
            date: 'MMM D',
            longDate: 'dddd, MMMM D',
            dateTimeShort: `MMM D, ${time}`,
            dateTime: `MMM D [at] ${time}`,
            fullDate: 'YYYY, MMM D',
            machineFriendlyFullDate: 'YYYY/MM/DD',
            fullDateTime: `YYYY, MMM D [at] ${time}`,
        }
    };
};

export const altDateFormat = dateFormat => dateFormat.replace(/D/g, 'd').replace(/Y/g, 'y').replace(' [at]', '');
